import React from "react";
import "./MobileMain.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

const MobileMainPage = () => {
  const casesData = [
    { name: "Floya", image: "/images/case2.png", tags: "UI/UX, Веб-дизайн" },
    { name: "Ramstore", image: "/images/case3.png", tags: "UI/UX, Веб-дизайн" },
    { name: "Хозяин горбушки", image: "/images/case4.png", tags: "UI/UX, Дизайн" },
    { name: "Mr.Bond", image: "/images/case5.png", tags: "UI/UX, Дизайн" },
  ];

  const gamesData = [
    { name: "Highway Run", image: "/images/game1.png", status: "В разработке", year: "2025" },
    { name: "Хранитель рощи", image: "/images/game2.png", status: "В разработке", year: "2025" },
    { name: "Timber Dojo", image: "/images/game3.png", status: "Демо", year: "2025" },
  ];

  const teamData = [
    { name: "Павел Таймер", image: "/images/pavel.png" },
    { name: "Михаил Луканин", image: "/images/misha.png" },
    { name: "Егор Гайнцев", image: "/images/egor.png" },
  ];

  return (
    <div className="m">
      {/* ==== BACKGROUNDS (адаптация с десктопа) ==== */}
      <div className="m-bg m-bg--1" style={{ backgroundImage: `url("/images/background-1.png")` }} />
      <div className="m-bg m-bg--2" />
      <div className="m-bg m-bg--3" style={{ backgroundImage: `url("/images/background-2.png")` }} />
      <div className="m-bg m-bg--4" />
      <div className="m-bg m-bg--5" style={{ backgroundImage: `url("/images/space-cosmo.png")` }} />
      <div className="m-bg m-bg--6" />
      <div className="m-bg m-bg--7" />
      <div className="m-bg m-bg--8" style={{ backgroundImage: `url("/images/background-5.jpg")` }} />
      <div className="m-bg m-bg--9" />
      <div className="m-bg m-bg--10" style={{ backgroundImage: `url("/images/background-6.jpg")` }} />
      {/* HERO */}
      <header className="m-hero">
        <img src="/images/logo.png" className="m-hero__logo" alt="BunkerDev" />

        <h1 className="m-hero__title">
          Мы создаём решения, <br />
          <span>которые формируют будущее</span>
        </h1>

        <p className="m-hero__subtitle">
          Digital агентство: сайты, игры, приложения, боты, дизайн.
        </p>

        <a href="https://t.me/thehypeprogrammer" target="_blank" className="m-btn m-btn--primary">Связаться с нами</a>
        <a className="m-btn m-btn--games" onClick={() => document.getElementById("games").scrollIntoView({ behavior: "smooth" })}>Наши игровые проекты</a>
        <a className="m-btn m-btn--cases" onClick={() => document.getElementById("cases").scrollIntoView({ behavior: "smooth" })}>Посмотреть кейсы</a>
      </header>

      {/* CASES */}
      <section className="m-section">
        <h2 className="m-section__title" id="cases">Кейсы / Проекты</h2>

        <Swiper
          slidesPerView={1.1}
          spaceBetween={20}
          className="m-swiper"
        >
          {casesData.map((item, i) => (
            <SwiperSlide key={i}>
              <div className="m-case">
                <img src={item.image} alt={item.name} />
                <h3>{item.name}</h3>
                <p>{item.tags}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      {/* TEAM */}
      <section className="m-section">
        <h2 className="m-section__title" id="team">Команда</h2>

        <Swiper slidesPerView={1.15} spaceBetween={24}>
          {teamData.map((item, i) => (
            <SwiperSlide key={i}>
              <div className="m-team-card">
                <img className="m-team-card__image" src={item.image} />
                <h3 className="m-team-card__name">{item.name}</h3>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      {/* GAMES */}
      <section className="m-section">
        <h2 className="m-section__title" id="games">Игры / GameDev</h2>

        <Swiper slidesPerView={1.1} spaceBetween={20}>
          {gamesData.map((item, i) => (
            <SwiperSlide key={i}>
              <div className="m-game">
                <img src={item.image} alt={item.name} />
                <h3>{item.name}</h3>
                <div className="m-game__info">
                  <span>Статус: {item.status}</span>
                  <span>Год: {item.year}</span>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      {/* COOPERATION */}
      <section className="m-coop">
        <h2 className="m-section__title">Сотрудничество</h2>

        <p className="m-coop__text">
          Мы открыты к партнёрствам и сотрудничеству.  
          <span>Присоединяйтесь к нам и создавайте будущее вместе.</span>
        </p>

        <a href="https://t.me/thehypeprogrammer?text=Добрый день! Я по поводу сотрудничества с BunkerDev" target="_blank" className="m-btn m-btn--primary">Сотрудничество</a>
      </section>

      {/* === SOCIAL ICONS === */}
      <div className="m-social">
        <a
          className="m-social__link"
          target="_blank"
          href="https://t.me/bunkerdevs"
        >
          <img src="/images/telegram-icon.svg" alt="Telegram" />
        </a>
        <a
          className="m-social__link"
          target="_blank"
          href="https://vk.com/bunkerdev"
        >
          <img src="/images/vk-icon.svg" alt="VK" />
        </a>
      </div>
        
      <footer className="m-footer">© Все права защищены 2025</footer>
    </div>
  );
};

export default MobileMainPage;
